import classNames from 'classnames';
import { observer } from 'mobx-react-lite';
import { FC } from 'react';

import { usePopover } from '@gem/ui-kit';

import { Avatar, AvatarTypes } from 'APP/components/Avatar/Avatar';
import { SenderPopoverMenuForAdmin } from 'APP/main/ChatView/Messages/Message/components/SenderPopoverMenuForAdmin/SenderPopoverMenuForAdmin';
import { ChatMessage } from 'STORE/Messages/Message/ChatMessage/ChatMessage';

import { useSenderAvatarPresenter } from '../SenderAvatar.presenter';
import styles from './SenderAvatarForAdmins.styles.m.css';

interface ISenderChannelAvatarProps {
  message: ChatMessage;
}

export const SenderAvatarForAdmins: FC<ISenderChannelAvatarProps> = observer((props) => {
  const { message } = props;
  const popover = usePopover<HTMLButtonElement>();

  const commonPresenter = useSenderAvatarPresenter(message);

  return (
    <>
      <button
        className={classNames({ [styles.avatar]: commonPresenter.senderId })}
        ref={popover.containerRef}
        onClick={popover.toggle}
      >
        <Avatar
          type={AvatarTypes.Round_0}
          url={message.avatarUrl}
          title={message.avatarTitle}
          backgroundColorIndex={message.avatarColorIndex || '0'}
        />
      </button>
      {commonPresenter.senderId && (
        <SenderPopoverMenuForAdmin
          message={message}
          senderId={commonPresenter.senderId}
          popover={popover}
        />
      )}
    </>
  );
});
